import { Typography, Button, Box, Grid, Container } from '@mui/material';
import React, { useEffect, useState, useRef } from 'react';
import ContactformEN from './ContactformEN';
import { HashLink } from 'react-router-hash-link';
import ResponsiveAppBarAltEN from './ResponsiveAppBarAltEN';
import FooterEN from "./FooterEN";
import '../App.css';

const ScrollAnimation = () => {

    const [isHeroNavVisible, setIsHeroNavVisible] = useState(true);

    const heroNavWrapperRef = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
            const screenHeight = window.innerHeight;

        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsHeroNavVisible(entry.isIntersecting);
                const navbar = document.querySelector(".navbar.alt");
                if (navbar) {
                    if (!entry.isIntersecting) {
                        navbar.style.marginTop = "0px";
                    } else {
                        navbar.style.marginTop = "-100px";
                    }
                }
            },
            { threshold: 0.01 }
        );

        if (heroNavWrapperRef.current) {
            observer.observe(heroNavWrapperRef.current);
        }

        return () => {
            if (heroNavWrapperRef.current) {
                observer.unobserve(heroNavWrapperRef.current);
            }
        };
    }, []);

    // Visibility Notarinfo
    const [isVisibleN1, setIsVisibleN1] = useState(false);
    const [isVisibleN2, setIsVisibleN2] = useState(false);

    const toggleVisibility = (elementId) => {
        if (elementId === 'elementToToggle1') {
            setIsVisibleN1(!isVisibleN1);
        } else if (elementId === 'elementToToggle2') {
            setIsVisibleN2(!isVisibleN2);
        }
    };

    return (
        <Box className="containerMain">

            <ResponsiveAppBarAltEN />

            <div className="App">
                <main>
                    <div>
                        <Box className="heroWrapper" id="start">
                            <img src="Michaelsberg-Siegburg.webp" className='herobackimg' />
                            <Box className='heroWrapperLayer'></Box>
                            <Container maxWidth="lg" className="containerHero" /*sx={{width: 300,backgroundColor: 'success.main',}}*/>
                                <Box className="HeroBox">
                                    <img src='HT-Logo.png' className='HeroLogoImg' />
                                    <Typography variant='h1' align='center' color="textPrimary" gutterBottom>
                                        Harbecke & Thelen <br />
                                        Notaries
                                    </Typography>
                                    {/* <div>
                                        <Button href="/#kontakt" variant='contained' className='heroCTA'>
                                            Kontakt
                                        </Button>
                                    </div> */}
                                </Box>

                            </Container>

                            <Box className="heroNavWrapper" ref={heroNavWrapperRef}>
                                <HashLink className='navItemHero' smooth to="en/#leistungen">Services</HashLink>
                                <HashLink className='navItemHero' smooth to="en/#notare">Notaries</HashLink>
                                <HashLink className='navItemHero' smooth to="/Team">Team</HashLink>
                                <HashLink className='navItemHero' smooth to="en/#kontakt">Contact</HashLink>
                                <HashLink className='navItemHero flex' smooth to="/"><img src="de-flag.png" className='navFlagIcon' />DE</HashLink>
                            </Box>

                        </Box>



                        <Box className="mainWrapper">

                            <Box className="section" id="subhero">
                                <Container maxWidth="lg" className="container">
                                    <Box className="textBox">
                                        <Grid container justifyContent="center" spacing={2}>
                                            <Grid container item xs={12} sm={12} spacing={0} className='textIntendOuterFlexbox'>
                                                <Box className="intendTextWrapper">
                                                    <Typography variant='h2' className='subtitleH3'>Welcome to our office!</Typography>
                                                    <Box className="textintendInnerWrapper">
                                                        <Typography variant='body1'>Regardless of whether you want to buy real estate property, write your last will and testament or set up a company – we are at your side as legal advisors for all important life decisions. Our aim is to develop pragmatic solutions for you at the highest professional level.</Typography>
                                                    </Box>
                                                </Box>
                                                <Box className="intendTextWrapper">
                                                    <Typography variant='h2' className='subtitleH3'>You can send us your request online </Typography>
                                                    <Box className="textintendInnerWrapper">
                                                        <Typography variant='body1'>You can use our contact form to tell us about your individual concerns at any time of day or night. We will get back to you as soon as possible. </Typography>
                                                        <div className="ctaWrapper fadeInOpac">
                                                            <HashLink className='btnSecondary' smooth to="#kontakt">Contact form</HashLink>
                                                        </div>
                                                    </Box>
                                                </Box>
                                            </Grid>

                                        </Grid>
                                    </Box>
                                </Container>
                            </Box>


                            <Box className="section leistungen" id="info">
                                <Container maxWidth="lg" className="container" id="leistungen">
                                    <Box className="intendTextWrapper textBox">
                                        <Typography variant='h2' className='subtitleH3 whiteText'>Our services</Typography>
                                        <Box className="textintendInnerWrapper">
                                            <Typography variant='body1' className='whiteText'>We offer notarial services especially in the following matters:</Typography>

                                            <ul className='servicesList'>
                                                <li><Typography variant='body1' className='whiteText'>Buy or sell real estate property</Typography></li>
                                                <li><Typography variant='body1' className='whiteText'>Transfer of real estate property to the next generation</Typography></li>
                                                <li><Typography variant='body1' className='whiteText'>Last Will and Testament</Typography></li>
                                                <li><Typography variant='body1' className='whiteText'>Powers of Attorney</Typography></li>
                                                <li><Typography variant='body1' className='whiteText'>Family Law Issues</Typography></li>
                                                <li><Typography variant='body1' className='whiteText'>Companies</Typography></li>
                                                <li><Typography variant='body1' className='whiteText'>Nonprofit Associations</Typography></li>
                                                <li><Typography variant='body1' className='whiteText'>Certification of Documents and Autentification of Signatures</Typography></li>
                                            </ul>
                                        </Box>
                                    </Box>

                                </Container>
                            </Box>

                            <Box className="section" id="notare">
                                <Container maxWidth="lg" className="container section" id="notare">

                                    <Box className="intendTextWrapper">
                                        <Typography variant='h2' className='sectionTitle'>
                                            Notaries
                                        </Typography>
                                        <Box className="textintendInnerWrapper">
                                            <Typography variant='body1'>Dr. Antonia Harbecke, MJur (Oxford) and Dr. Martin Konstantin Thelen, LL.M. (Columbia) both studied German Law and Common Law. They offer notarizations in German and English. If you do not speak either of these languages, please ask an official translator to assist you in the notarization process. </Typography>

                                            <Box className="notarGrid">

                                                <Box className="teamItem">
                                                    <Box className="teamImgWrapper">
                                                        <img src='Harbecke-Profil.webp' className='teamImg' />
                                                    </Box>
                                                    <Box className="teamItemTextWrapper">
                                                        <Typography variant='body1'><b>Notarin Dr. Antonia Harbecke</b><br />MJur (Oxford)</Typography>
                                                    </Box>
                                                </Box>

                                                <Box className="teamItem">
                                                    <Box className="teamImgWrapper">
                                                        <img src='Thelen-Profil.webp' className='teamImg' />
                                                    </Box>
                                                    <Box className="teamItemTextWrapper">
                                                        <Typography variant='body1'><b>Notar Dr. Martin Konstantin Thelen</b><br />LLM (Columbia)</Typography>
                                                    </Box>
                                                </Box>
                                            </Box>

                                        </Box>
                                    </Box>


                                </Container>
                            </Box>

                            <Box className="section leistungen" id="info">
                                <Container maxWidth="lg" className="container" id="leistungen">
                                    <Box className="intendTextWrapper">
                                        <Typography variant='h2' className='subtitleH3 whiteText'>Important Information considering Certification and Authentification</Typography>
                                        <Box className="textintendInnerWrapper">
                                            <Typography variant='body1' className='whiteText'>Various authorities in Germany and abroad require a document to be certified or a signature to be authenticated by a notary. When certifying a copy, the notary only checks that the document presented to him is identical to the copy he is issuing. When authenticate signatures, the notary only checks whether the correct person is signing the document using an official photo ID. Please bring a valid passport, Personalausweis or German Residence Permit wih you if you want us to authenticate your signature. For security reasons, we will check the authenticity of your ID Card. <br /><br />

                                                If you want to use a document abroad, you will usually need an additional special notarization. The so-called apostille is issued by the President of the Regional Court of Bonn. We can submit the document to the Regional Court of Bonn on your behalf and apply for the apostille to be issued. Other countries require the time-consuming legalization of the document by a consulate. Please check in advance with the foreign authorities what type of proof they require.</Typography>

                                        </Box>
                                    </Box>

                                </Container>
                            </Box>

                            <Box className="map" id="map">
                                <Box className="contactMap en">
                                    <iframe width="100%" height="100%" frameBorder="0" allowFullScreen allow="geolocation" src="//umap.openstreetmap.de/en/map/notare-harbecke-thelen_85729?scaleControl=false&miniMap=false&scrollWheelZoom=false&zoomControl=true&editMode=disabled&moreControl=true&searchControl=null&tilelayersControl=null&embedControl=null&datalayersControl=true&onLoadPanel=none&captionBar=false&captionMenus=true"></iframe>
                                </Box>

                                {/* <Container maxWidth="lg" id="routelink">
                                    <Typography variant='body1' paragraph className="contactMapRouteLink">Einen Routenplaner finden sie <a href="https://www.google.com/maps/dir//Notarin%20Dr.%20Antonia%20Harbecke,%20Holzgasse%2029-33,%2053721%20Siegburg" target="_blank">hier</a>.</Typography>
                                </Container> */}

                            </Box>

                            <Box className="section bannergrey" id="kontakt">
                                <Container maxWidth="lg" className="container" id="kontakt">
                                    <Box className="kontaktGrid">
                                        <Box className="kontaktLeftSide smaller">
                                            <Typography variant='h2' className='sectionTitle white'>
                                                Contact
                                            </Typography>
                                            <Typography variant='body1' paragraph className='whiteText'>
                                                <b>Opening Hours</b><br />
                                                Monday to Friday from 8 am to 1 pm and 2 to 5 pm<br />
                                                Wednesday closed from 1 pm<br />
                                                Later appointments are possible by appointment<br />
                                            </Typography>
                                            <Typography variant='body1' paragraph className='whiteText'>
                                                <b>Telephone number</b><br />
                                                You can reach us under 02241 66444<br />
                                                Monday to Friday from 9 am to 1 pm and 2 to 5 pm<br />
                                                Wednesday only until 1 pm
                                            </Typography>
                                            <Typography variant='body1' paragraph className='whiteText'>
                                                <b>E-mail: info@ht-notare.de</b><br />
                                            </Typography>
                                            <Typography variant='body1' paragraph className='whiteText'>
                                                <b>Directions and parking facilities</b><br />
                                                The office is located in the center of Siegburg in Holzgasse No. 29 - 33. The office rooms are on the second floor and are barrier-free accessible by means of an elevator and stair lift.<br />
                                                Parking is available in the Holzgasse multi-storey parking lot and in the Galeria Kaufhof and Saturn multi-storey parking lots about 100 meters away from our office.
                                            </Typography>
                                        </Box>
                                        <ContactformEN />
                                    </Box>
                                </Container>


                            </Box>

                        </Box>



                    </div>
                </main >
            </div >

            <FooterEN />

        </Box >


    );
};

export default ScrollAnimation;